import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  zh: {
    translation: translationZH
  }
};

// Read saved language preference from localStorage BEFORE initialization
// This ensures the correct language is used from the very first render
// IMPORTANT: This is temporary - the real language comes from the database on app load
const getSavedLanguage = (): string => {
  try {
    const savedLanguage = localStorage.getItem('userLanguage');
    // Validate that the saved language is one we support
    if (savedLanguage === 'en' || savedLanguage === 'zh') {
      console.log('[i18n] 📦 Initializing with cached language from localStorage:', savedLanguage);
      return savedLanguage;
    }
  } catch (error) {
    console.warn('[i18n] Could not read saved language from localStorage:', error);
  }
  // Default to Chinese as fallback (most users are Chinese)
  console.log('[i18n] ⚠️ No cached language, defaulting to: zh (will be updated from database)');
  return 'zh';
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector) // Optional: Can enable if needed, but we default to 'zh'
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: 'zh', // Default to Chinese if detected language is unavailable
    lng: getSavedLanguage(), // Get language from localStorage or default to Chinese
    debug: process.env.NODE_ENV === 'development', // Enable debug output in dev mode

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

export default i18n; 